import { render, staticRenderFns } from "./PfLoanPublicInfo.vue?vue&type=template&id=25964980"
import script from "./PfLoanPublicInfo.vue?vue&type=script&lang=js"
export * from "./PfLoanPublicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports